import styled from 'styled-components';
import Input from '@paradigm/design-system/src/components/Input';
import { MOBILE_BREAKPOINT } from '@paradigm/design-system/src/units';

export const BaseNumericField = styled(Input).attrs({
  variant: 'transparent',
  inputType: 'numeric',
  size: 'small',
})`
  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    input {
      padding: 0;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    opacity: 1;
    color: white;
  }
`;
